var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('el-scrollbar',[_c('depts',{ref:"deptTree",on:{"nodeClick":_vm.onDeptTreeNodeClick}})],1),_c('staffs',{ref:"staffTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }